import React from "react"
import PropTypes from "prop-types"
import Title from "components/views/Title"
import { SinglePathSVG } from "components/views/SVG"
import styled from "styled-components"
import { breakpointNotSmall, breakpointSmall } from "css/variables/_breakpoints.scss"
import { ButtonPrimary } from "../atoms/buttons/ButtonPrimary"
import { RetinaImage } from "../atoms/images/RetinaImage"
import { Form } from "components/views/atoms/forms/Form"
import Settings from "../../../utils/CarrotConfig"

const CarrotDot = () => (
  <div className="absolute right-0 left-0 justify-center flex justify-left nt5">
    <a className="carrot-orange hover-black" href={Settings.CARROT_BACKEND_URL}>
      <div className="w4 h4 flex items-center pa3 br-100 bg-carrot-orange white">
        <SinglePathSVG icon="newLogo" />
      </div>
    </a>
  </div>
)

const AuthLayoutInner = styled.div`
  @media ${breakpointNotSmall} {
    max-width: 512px;
    min-width: 512px;
  }
  @media ${breakpointSmall} {
    min-width: 343px;
  }
`

const SplashImg = ({ side, className }) => (
  <RetinaImage className={`z-0 ${className}`} name={`illo-login-splash-${side}`} width={268} height={260.56} />
)

const AuthLayout = ({ title, children }) => (
  <div className="w-100 pa3 min-vh-100 flex justify-center items-center bg-pattens-blue overflow-hidden">
    <Title title={title} />
    <SplashImg side="left" className="nr5" />
    <AuthLayoutInner className="w-100 z-1 nt5">{children}</AuthLayoutInner>
    <SplashImg side="right" className="nl5" />
  </div>
)

const RoundedBox = styled.div`
  width: 100%;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
`

const AuthCard = ({ shake, onSubmit, children, id }) => {
  const shakeClass = shake ? "shake" : ""
  return (
    <div id={id} className={`relative mt5 ${shakeClass}`}>
      <CarrotDot />
      <Form onSubmit={onSubmit}>
        <RoundedBox>
          <div className="ph35-s ph45 pt35 pb3">{children}</div>
        </RoundedBox>
      </Form>
    </div>
  )
}

AuthCard.propTypes = {
  shake: PropTypes.bool,
  onSubmit: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  id: PropTypes.string
}

const AuthButton = styled(ButtonPrimary)`
  width: 180px;
  padding-top: 10px;
  padding-bottom: 10px;
  line-height: 20px;
  white-space: nowrap;
  text-align: center;
`

export { AuthCard, AuthLayout, AuthButton }
